var map = {
	"./1-1.png": "ff02",
	"./1-2.png": "98ff",
	"./2-1.png": "c1dd",
	"./2-2.png": "04e5",
	"./2-3.png": "8099",
	"./2-4.png": "3d60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93c1";